<div class="activity-draft-card">
  <div class="activity-draft-card__content">
    <img
      *ngIf="picture"
      alt="{{ 'organizer.activity.draft.picture_alt' | translate }}"
      class="activity-draft-card__image"
      [src]="picture"
    />
    <vtmn-play-icon
      *ngIf="!picture"
      [name]="iconTypeEnum?.CloseCircle"
      [ariaLabel]="'a11y.organizer.draft.activity.image' | translate"
      class="activity-draft-card__app-icon"
    ></vtmn-play-icon>
    <div class="activity-draft-card__info-container">
      <p class="activity-draft-card__custom-content">
        {{ 'organizer.activity.draft.missing_date' | translate }}
      </p>

      <div class="activity-draft-card__title">
        <span>{{ 'organizer.activity.draft.saved_draft' | translate }}</span>
        <span *ngIf="!draftActivity.sports"
          >{{ 'organizer.activity.draft.missing_sport' | translate }} -
        </span>
        <span>{{ title }}</span>
      </div>

      <p class="activity-draft-card__address">
        {{ address }}
      </p>

      <div class="flex flex-wrap">
        <app-badge
          *ngIf="!hasOffers"
          class="activity-draft-card__price"
          [variant]="priceBadgeVariant"
        >
          {{ draftPrice }}
        </app-badge>

        <app-badge
          *ngIf="isLive"
          class="activity-draft-card__live"
          [variant]="badgeVariantSecondary"
          [icon]="iconTypeEnum.Video"
          iconClass="text-red"
        >
          {{ 'component.activity_card.live' | translate }}
        </app-badge>

        <app-badge
          class="activity-draft-card__duration"
          [variant]="badgeVariantSecondary"
        >
          <time>
            {{ duration }}
          </time>
        </app-badge>
      </div>
    </div>
  </div>
</div>
